import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistAnswerDeleteModel } from 'shared/domain/checklistAnswer/types/model';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistAnswerHttpDeleteRequestModel } from '../httpQueue/checklistAnswer/types';

export class ChecklistAnswerDeleter {
  constructor(
    private addRequest: (
      request: ChecklistAnswerHttpDeleteRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    deleteModel: ChecklistAnswerDeleteModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('DeleteChecklistAnswerUseCase', deleteModel);

    const url = `/project/${deleteModel.projectId}/inspectionTemplate/${deleteModel.inspectionTemplateId}/checklistItem/${deleteModel.checklistItemId}/checklistAnswer/${deleteModel._id}`;

    const request: ChecklistAnswerHttpDeleteRequestModel = {
      createdAt: Date.now(),
      method: 'DELETE',
      data: {
        answerId: deleteModel._id,
        projectId: deleteModel.projectId,
        inspectionTemplateId: deleteModel.inspectionTemplateId,
        checklistItemId: deleteModel.checklistItemId,
        uniqueId: uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistAnswer,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistAnswerDeleter = new ChecklistAnswerDeleter(addRequest);
